import React from 'react'

function ActivityPage() {
  return (
    <div>
      Activity Page
    </div>
  )
}

export default ActivityPage
